module.exports = __webpack_public_path__ + "img/10.96191eb9.png";